export const replaceNbsps = (str: string): string => {
  const re = new RegExp(String.fromCharCode(160), 'g');
  return str.replace(re, ' ');
};
